export enum WorkspaceType {
  Personal = 1,
  Assigned = 2,
}

export enum MembershipRole {
  Admin = 1,
  Member = 2,
}

export enum MembershipStatus {
  Active = 1,
  Disabled = 2,
  Pending = 3,
}
